<script setup lang="ts">
const root = ref<HTMLElement | null>(null)
useReveal(root)
const portfolioStore = usePortfolioStore()
const supportedSections = ['hero', 'services', 'projects', 'contact']
const sections = computed(() =>
  portfolioStore.visibleSections.filter(section => supportedSections.includes(section))
)
const { active, go } = useActiveSection(sections)
const hasSection = (section: string) => sections.value.includes(section)
</script>

<template>
  <main ref="root" class="mx-auto flex w-full flex-wrap items-start gap-4">
    <AtlasTempPartialsSideBar class="order-3 md:order-1" />
    <div class="order-2 flex min-w-0 flex-1 flex-col gap-4 md:order-2">
      <AtlasTempPartialsHero v-if="hasSection('hero')" />
      <AtlasTempPartialsServices v-if="hasSection('services')" />
      <AtlasTempPartialsProjects v-if="hasSection('projects')" />
      <AtlasTempPartialsContacts v-if="hasSection('contact')" />
      <SharedSiteFooter class="px-4" />
    </div>
    <AtlasTempPartialsRail :active="active" :sections="sections" class="order-1 md:order-3" @go="go" />
  </main>
</template>
